import React from "react";
import "./products.css";
import PageHeader from "../page-header";
const Products = () => {
  return (
    <section className="products-sec">
      <PageHeader
        headertitle="Products"
        imgsrc="/assets/img/selfmade/Images/Product.png"
      />
      <div className="privacyInfo-center">
        <h2>
          Extended Trust <span>Products</span>
        </h2>
        <h4>
          {/* Path to Worry Free Driving */}
          OIL CHANGE PROGRAM
        </h4>
        <p>
          Explore our exclusive five year program, designed to provide peace of
          mind and hassle free maintenance for your vehicle. Also Includes 3
          year tire storage program with the option to upgrade to lifetime oil
          changes and tire storage services
        </p>
        <h4>Brakes and Rotors</h4>
        <p>
          Prioritize safety with our "Brakes and Rotors" program. Comprehensive
          coverage for your braking system ensures optimal performance and
          responsiveness. From brake pad replacements to rotor maintenance,
          trust us to keep your vehicle braking smoothly, providing you with
          peace of mind on every journey.
        </p>
        <h4>
          Customized programs
        </h4>
        <p>
          Customized programs give customers exactly what they need, 
          creating a more relevant and flexible experience that builds trust, 
          improves satisfaction, and increases long-term loyalty. 
          By tailoring services to individual vehicle history and usage, businesses can deliver more consistent value, 
          strengthen retention, and improve overall customer experience scores.
        </p>
      </div>
    </section>
  );
};

export default Products;

